import { Directive, TemplateRef } from '@angular/core';

/**
 * Marks an `ng-template` as the row-expansion body for {@link KlGrid}.
 * Context: `{ $implicit: row, item: row }` (same as legacy `let-item="item"`).
 * PrimeNG 21 wires expansion via `pTemplate="expandedrow"` on `p-table` (not `rowexpansion`).
 */
@Directive({
  selector: '[klGridRowDetail]',
  standalone: true,
})
export class KlGridRowDetailDirective {
  constructor(readonly templateRef: TemplateRef<object>) {}
}
